import 'angular:locale/data:es-AR';
import 'zone.js';(globalThis.$localize ??= {}).locale = "es-AR";
